import React, { ReactElement } from 'react'
import { Navigate, useParams } from 'react-router-dom'

export const BusinessUnitsIndexRedirect = (): ReactElement => {
  const { businessKey } = useParams()
  return (<Navigate to={`/business-units/${businessKey}/crm/contact`} replace />)
}
